export default __webpack_public_path__ + "static/media/p-plus-1.e8ce1217.svg";